import { config } from './index';

export type SuiNetwork = 'mainnet' | 'testnet' | 'devnet';

export const defaultSuiNetwork = config.sui.network;

export const suiGraphQlEndpoints: Record<SuiNetwork, string> = {
  mainnet: 'https://graphql.mainnet.sui.io/graphql',
  testnet: 'https://graphql.testnet.sui.io/graphql',
  devnet: 'https://graphql.devnet.sui.io/graphql',
};

export const suiGraphQlUrl = suiGraphQlEndpoints[defaultSuiNetwork];

const SUI_EXPLORER_URL = 'https://suiscan.xyz';

export const getSuiExplorerTransactionUrl = (digest: string): string =>
  `${SUI_EXPLORER_URL}/${defaultSuiNetwork}/tx/${encodeURIComponent(digest)}`;

export const getSuiExplorerAddressUrl = (address: string): string =>
  `${SUI_EXPLORER_URL}/${defaultSuiNetwork}/account/${encodeURIComponent(address)}`;
